var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
		'rounded-md border border-green-200 bg-green-50 p-4': _vm.type == 'success',
		'rounded-md border border-red-200 bg-red-50 p-4': _vm.type == 'error',
	}},[_c('div',{staticClass:"flex items-center"},[_c('ui-icon',{staticClass:"flex-shrink-0",class:{
				'h-5 w-5 text-green-500': _vm.type == 'success',
				'h-5 w-5 text-red-500': _vm.type == 'error',
			},attrs:{"name":_vm.type == 'success'
					? 'check-circle'
					: _vm.type == 'error'
					? 'alert-triangle'
					: '',"stroke-width":"2"}}),_vm._v(" "),_c('div',{staticClass:"ml-3"},[_c('span',{class:{
					'text-sm font-medium text-green-500': _vm.type == 'success',
					'text-sm font-medium text-red-500': _vm.type == 'error',
				}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.__(_vm.message))+"\n\t\t\t\t"),(_vm.bulletPoints)?_c('ul',{staticClass:"list-disc pl-5 space-y-1",attrs:{"role":"list"}},_vm._l((_vm.bulletPoints),function(message,idx){return _c('li',{key:idx},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(message)+"\n\t\t\t\t\t")])}),0):_vm._e()])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }